<template>
  <div id="content" class="starting_page">
        <ProjectModeModal :dialogVisible="showmodemodal" @useAI='useAI()'
@useClassic='useClassic'
@cancelChoice='cancelProjectModeChoice'></ProjectModeModal>
    <div class="banner">
        <span class="tline1">START A PERSONALIZED JOURNEY</span>
        <span class="tline2">To your next innovation partnership</span>
    </div>
    <div class="innopearl_card_container">
      <div class="container">


      <div class="row">


      <div class="innopearl_card col-12 col-xl-4">
        <img :src="require('@/assets/start_target.svg')" class="innopearl_card_icon" alt="">
        <div class="innopearl_card_inner">

              <span class="innopearl_card_title">{{$t("TARGET")}}</span>
          <span class="innopearl_card_description">
{{$t("I have a business challenge to solve and seek to frame it and start a relevant solution search")}}
        </span>

          <div class="innopearl_card_inner_btn_div" v-if="business_challenge == false">
            <button type="button" class="innopearl_card_action" name="button" @click=" business_challenge = true ">select</button>
          </div>
           <img :src="require('@/assets/icon_selected.svg')"  v-if="business_challenge == true" @click="business_challenge = false " class="icon_selected" alt="">

        </div>
        <div class="absoluteBottom" v-if="business_challenge == true">
          <button type="button" class="innopearl_card_action" name="button" @click="initDumbProject()">GET STARTED</button>
        </div>
      </div>
      <div class="innopearl_card col-12 col-xl-4">
        <img :src="require('@/assets/start_scout.svg')" class="innopearl_card_icon" alt="">
        <div class="innopearl_card_inner">
            <span class="innopearl_card_title">{{$t("SCOUT")}}</span>
            <span class="innopearl_card_description">
              {{$t("I need to identify partners with solutions relevant to my business challenge")}}

            </span>

          <div class="innopearl_card_inner_btn_div" v-if="scouting_challenge == false">
            <button type="button" class="innopearl_card_action" name="button" @click="scouting_challenge = true ">select</button>
          </div>
           <img :src="require('@/assets/icon_selected.svg')"  v-if="scouting_challenge == true" @click="scouting_challenge = false " class="icon_selected" alt="">
        </div>
        <div class="absoluteBottom" v-if="scouting_challenge == true">
          <button type="button" class="innopearl_card_action" name="button" :disabled="business_challenge == true"  @click="initDumbProject()">GET STARTED</button>
        </div>
      </div>
      <div class="innopearl_card col-12 col-xl-4">
        <img :src="require('@/assets/start_assess.svg')" class="innopearl_card_icon" alt="">
        <div class="innopearl_card_inner">
                  <span class="innopearl_card_title">{{$t("ASSESS")}}</span>
            <span class="innopearl_card_description">
              {{$t("I have pre-selected potential candidates and seek to assess their strategic fit")}}

            </span>

          <div class="innopearl_card_inner_btn_div" v-if="assessment_challenge == false">
            <button type="button" class="innopearl_card_action" name="button" @click="assessment_challenge = true ">select</button>
          </div>
           <img :src="require('@/assets/icon_selected.svg')"  v-if="assessment_challenge == true" @click="assessment_challenge = false " class="icon_selected" alt="">

        </div>
        <div class="absoluteBottom" v-if="assessment_challenge == true">
          <button type="button" class="innopearl_card_action" name="button" :disabled="business_challenge == true || scouting_challenge == true"  @click="goToAssessemnt()">GET STARTED</button>
        </div>
      </div>
    </div>
  </div>      </div>
  </div>
</template>
<script>

import api from '../tools/api';
import {toast } from 'vue-sonner'
import ProjectModeModal from '@/components/ProjectModeModal.vue'

export default {
  components: {
    ProjectModeModal,
  },
  data() {

    return {
      showmodemodal:false,
      scouting_challenge : true,
      business_challenge : true,
      assessment_challenge : true,
      pageInfo: {
        mainTitle : "",
        subTitle : "",
      }
    }
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
  },
  methods: {
    useAI(){
      this.$router.push("/where_to_innovate_finder");
      this.showmodemodal = false;
    },
    useClassic(){
      this.initDumbProjectClassicMode();
      this.showmodemodal = false;
    },
    cancelProjectModeChoice(){
      this.showmodemodal = false;
    },
    getStarted(){
      //init project with basic info
      this.$router.push("/business_challenge_space");
    },
    goToAssessemnt(){
                  this.$router.push("/internalassessment_creation");
    },
    initDumbProjectClassicMode(){
      //This will set a project in DB and generate his oid
      var maybename = "Enter your project name";
      var p = {
        'challenges' : {
          'business_challenge' : this.business_challenge,
          'scouting_challenge' : this.scouting_challenge,
          'assessment_challenge' : this.assessment_challenge,
        },
        'name': (this.business_challenge) ? maybename : ""
      };
      api.post(process.env.VUE_APP_API_URL+"/restrict/project_init",p,{
          headers: {
              'Content-Type': 'application/json',
          }
      }).then( (r) => {
          console.log(r.data);
           toast.success("You're all set!")
            this.$router.push("/project_init/"+r.data.$oid);
      }).catch( (e) => {
          console.log(e);
          toast.error("There is an error !")
      });
    },
    initDumbProject(){
      this.showmodemodal = true;
    }
  }
}
</script>
<style >
.starting_page{
  padding-bottom: 100px;
}

.banner{
padding-top:200px;
padding-bottom: 200px;
padding-left:10px;
padding-right: 10px;
min-height:50vh;
background: url('@/assets/bannerCreation.png');
background-size: cover;
background-position: center;
}
.tline1{
  text-align: center;
  font-size: 40px;
  line-height: 49px;
  font-weight: 600;
letter-spacing: 0px;
color: #FFFFFF;
text-transform: uppercase;
opacity: 1;
display: block;
}
.tline2{
  text-align: center;
  font-size: 40px;
  line-height: 49px;
  font-weight: 400;
letter-spacing: 0px;
color: #FFFFFF;
opacity: 1;
display: block;
}
.tline3{
  text-align: center;
  font-size: 23px;
  line-height: 28px;
  font-weight: 900;
letter-spacing: 0px;
color: #FFFFFF;
text-transform: uppercase;
opacity: 1;
display: block;
margin-top:50px;
}
.innopearl_card_container{
  /* padding-left:100px;
  padding-right:100px; */
  margin-top: -150px;
  margin-bottom: 150px;
}
.innopearl_card{
margin-top:20px;
display: flex;
flex-direction: column;
margin-bottom: 100px;
position:relative;
}
/*
.innopearl_card_container{
  display:flex;
  gap: 100px;
  padding-left:100px;
  padding-right:100px;
  margin-top: -150px;
  margin-bottom: 150px;
}
.innopearl_card{
flex-basis: 0;
flex: 1 1 0px;

} */

.innopearl_card_inner{
  background:#FFF;
  box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
width: 100%;
padding-bottom: 50px;
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  flex: 1;

}
.innopearl_card_content{
  padding-left:50px;
  padding-right:50px;
}
.innopearl_card_icon{
  width: 100px;
  margin-bottom:-50px;
  display: block;
  margin-left:auto;
  margin-right:auto;
  z-index:100;
}

.innopearl_card_description{
  display:block;
  text-align: center;
  max-width:300px;
  margin-left: auto;
  margin-right: auto;
font-size:18px;
line-height:24px;
letter-spacing: 0px;
color: #B38D2F;
opacity: 1;
font-weight: 300;
margin-top:20px;
margin-bottom: 20px;
padding-right: 20px;
padding-left: 20px;
}

.innopearl_card_title{
  display:block;
  text-align: center;
font-size:34px;
line-height:40px;
letter-spacing: 0px;
font-weight: 500;
opacity: 1;
padding-right: 20px;
padding-left: 20px;
margin-top: auto;
color:#3783C5;
margin-top:20px;
}


.innopearl_card_action{
  background: #3783C5 ;
border-radius: 200px;
text-align: center;
font-size:14px;
line-height: 17px;
font-weight: 600;
padding:  15px 45px;
letter-spacing: 0px;
color: #FFFFFF;
margin: auto;
display:block;
margin-top: 20px;

 height:60px;
}

.innopearl_card_action:disabled{
  background: #D6D6D6 0% 0% no-repeat padding-box;
}
.icon_selected{
text-align: center;
font-size: 14px;
line-height: 17px;
font-weight: 600;
padding: 15px 45px;
letter-spacing: 0;
color: #fff;
margin: auto;
display: block;
margin-top: 20px;
margin-bottom: auto;
height:60px;
width:100%;
object-fit: contain;
object-position: center;
}



.absoluteBottom{
  position:absolute;
  bottom: -100px;
  left:0;
  right:0;
}
</style>
